// extracted by mini-css-extract-plugin
export default {"nav":"Header_nav__Dwsxa","title":"Header_title__NuC-r","logo":"Header_logo__Tz5W4"};